(function () {
  'use strict';

  angular
    .module('events')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('events', {
        abstract: true,
        url: '/events',
        templateUrl: 'events/events.tpl.html'
      })
    ;
  }
}());
